module.exports = __webpack_public_path__ + "img/banner_1@3x.90435e25.png";